import { useRuntimeConfig } from '#imports'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

/**
 * Gates the web shopping assistant (header search entry point + the
 * layout-mounted host).
 *
 * Backed by the `experiment.shoppingAssistantWeb` CloudBees experiment rather
 * than a runtime feature flag, so the rollout can be scoped to a QA audience
 * via targeting. Returns true only for the `withAssistant` variation.
 *
 * Also gated by FF_SHOPPING_ASSISTANT_ENABLED_COUNTRIES, independently of
 * experiment assignment, so availability can be restricted per country.
 */
export function useIsShoppingAssistantWebEnabled(): boolean {
  const { market } = useMarketplace()
  const { FF_SHOPPING_ASSISTANT_ENABLED_COUNTRIES } = useRuntimeConfig().public

  const isInExperiment =
    useExperiments()['experiment.shoppingAssistantWeb'] === 'withAssistant'
  const isCountryEnabled = Boolean(
    FF_SHOPPING_ASSISTANT_ENABLED_COUNTRIES?.includes(market.countryCode),
  )

  return isInExperiment && isCountryEnabled
}
